import { gql } from "@apollo/client";

export const COMPLIANCE_BUNDLE_FIELDS = gql`
  fragment ComplianceBundleFields on ComplianceBundle {
    orgName
    slug
    domain
    emailContact
    messageNature
    messagesPerDay
    donationRequestsEnabled
    tenDlcCampaignId
    tenDlcCampaign {
      tcrCampaignId
    }
    bundleTenants {
      id
      tenantId
      deletedAt
    }
    updatedAt
    createdAt
    createdByUser {
      id
      fullName
    }
    deletedAt
    deletedByUser {
      id
      fullName
    }
  }
`;

export const LIST_COMPLIANCE_BUNDLES = gql`
  ${COMPLIANCE_BUNDLE_FIELDS}
  query listComplianceBundles($input: ListComplianceBundlesInput!) {
    listComplianceBundles(input: $input) {
      bundles {
        id
        ...ComplianceBundleFields
      }
      totalCount
    }
  }
`;

export const CHECK_COMPLIANCE_BUNDLE_SLUG_AVAILABILITY = gql`
  query checkComplianceBundleSlug($input: CheckComplianceBundleSlugInput!) {
    checkComplianceBundleSlug(input: $input) {
      available
    }
  }
`;

export const CREATE_COMPLIANCE_BUNDLE = gql`
  ${COMPLIANCE_BUNDLE_FIELDS}
  mutation createComplianceBundle($input: CreateComplianceBundleInput!) {
    createComplianceBundle(input: $input) {
      id
      ...ComplianceBundleFields
    }
  }
`;

export const UPDATE_COMPLIANCE_BUNDLE = gql`
  ${COMPLIANCE_BUNDLE_FIELDS}
  mutation updateComplianceBundle($input: UpdateComplianceBundleInput!) {
    updateComplianceBundle(input: $input) {
      id
      ...ComplianceBundleFields
    }
  }
`;

export const DELETE_COMPLIANCE_BUNDLE = gql`
  ${COMPLIANCE_BUNDLE_FIELDS}
  mutation deleteComplianceBundle($input: DeleteComplianceBundleInput!) {
    deleteComplianceBundle(input: $input) {
      id
      ...ComplianceBundleFields
    }
  }
`;
